const stringIsNullOrWhitespace = (value: string | undefined): boolean => !value || value.trim() === '';

export default stringIsNullOrWhitespace;
